// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"5aba8db9","977":"ae6d7b2a"}[chunkId] + ".chunk.js";
};